var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8438 12.2808V4.06467C17.8858 3.86188 17.804 3.38147 17.1321 3.08614C16.5463 2.82822 15.9081 3.20821 15.717 3.45629C12.7987 7.83114 7.34414 17.0337 7.13208 17.4944C6.86334 18.0792 7.0481 18.4434 7.30004 18.7112C7.4932 18.912 7.9467 19.0321 8.19024 19.0321H14.1172L12.8533 29.0833C12.8849 29.3013 12.9892 29.5045 13.1514 29.6636C13.3135 29.8228 13.5252 29.9297 13.7561 29.9692C14.4342 30.1228 14.9024 29.6641 15.0515 29.414L24.7408 14.041C24.8793 13.8382 25.1733 13.2987 24.8625 12.8262C24.7434 12.6508 24.577 12.508 24.3801 12.4122C24.1833 12.3165 23.9629 12.2711 23.7414 12.2808H17.8438Z",
    fill: "url(#paint0_linear_3553_38753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3553_38753",
    x1: 18.1277,
    y1: 26.6801,
    x2: 3.3344,
    y2: 19.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyYellow);
export default __webpack_public_path__ + "static/media/energy_yellow.d28e888efbd169d4a77cca8d99017150.svg";
export { ForwardRef as ReactComponent };